<template>
  <div>
    <Modal v-model="modelAuth" width="400">
      <div slot="header" class="title">资质认证</div>
      <div class="content">需要您提供相关的资质认证</div>
      <div slot="footer" class="btn">
        <!-- <Button type="info" @click="goCompany">药企/研发认证</Button> -->
        <Button type="primary" @click="goPatient">患者认证</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "AuthModel",
  props: {
    modelAuth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {};
  },
  methods: {
    goCompany() {
      this.$parent.changeShowAuth();
      this.$router.push("/company");
    },
    goPatient() {
      this.$parent.changeShowAuth();
      this.$router.push("/patient");
    }
  }
};
</script>

<style lang="stylus" scoped>
.title
  text-align: center
  font-size: 16px
  font-weight: 700
.content
  text-align center
  font-size 14px
  margin: 10px
.btn
  margin: 10px auto;
  width: 220px;
  display: flex;
  justify-content: space-between;
  font-size: 14px
</style>
